import { createRoute } from "@tanstack/react-router";
import { Route as dashboardRoute } from "../dashboard";
import MeetingsViewEnhanced from "@/components/meetings/MeetingsViewEnhanced";
import { MEETINGS_TABS, type MeetingsTabType } from "@/components/meetings/tabs";
import { $api } from "@/lib/api";

const VALID_TABS = new Set<string>(MEETINGS_TABS);

type MeetingsSearch = {
  tab?: MeetingsTabType;
};

export const Route = createRoute({
  getParentRoute: () => dashboardRoute,
  path: "meetings",
  component: MeetingsViewEnhanced,
  validateSearch: (search: Record<string, unknown>): MeetingsSearch => ({
    tab: typeof search.tab === "string" && VALID_TABS.has(search.tab)
      ? (search.tab as MeetingsTabType)
      : undefined,
  }),
  loader: ({ context }) => {
    if (!localStorage.getItem("backendToken")) return;
    context.queryClient.prefetchQuery(
      $api.queryOptions("get", "/api/v1/meetings/enriched", {
        params: { query: { limit: 100 } },
      }),
    );
  },
});
